
<div class="column">
  <div class="top-bar">
    <div class="logo" data-testid="flat-layout-logo">
      KMU LOGO
    </div>
    <tps-flat-tabs data-testid="flat-layout-tabs" />
    <ngt-link (click)="testing.layout.set('mdi')" href="#" matIcon="open_in_new" target="" data-testid="flat-layout-change-to-mdi-layout-link">MDI Layout</ngt-link>
    <tps-assistant data-testid="flat-layout-open-assistant" />
  </div>
  <div class="app-content">
    <tps-feature-instance [urlPath]="tabService.getCurrentPath()" data-testid="flat-layout-feature-instance" />
  </div>
</div>
